import { render } from "./navigation-component.vue?vue&type=template&id=7b1df89e"
import script from "./navigation-component.vue?vue&type=script&lang=js"
export * from "./navigation-component.vue?vue&type=script&lang=js"

import "./navigation-component.vue?vue&type=style&index=0&id=7b1df89e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__